import type { ClientTasksLinkViewId } from "./organizationTasksLanding";

interface OrganizationTaskLinkParams {
    taskId: string;
    workspaceId: string;
}

export const getOrganizationTaskLink = ({
    taskId,
    workspaceId,
}: OrganizationTaskLinkParams) => {
    const searchParams = new URLSearchParams({
        taskId,
        taskWorkspaceId: workspaceId,
    });
    return `/clients-tasks?${searchParams.toString()}`;
};

interface OrganizationClientTasksLinkParams {
    workspaceId: string;
    /** A built-in view to open on; without it the page lands with no view. */
    viewId?: ClientTasksLinkViewId;
    /** Narrows the landing to one of the client's closes too. */
    closeId?: string;
}

/** The org Tasks page with a clean landing filtered to one client (see `useClientTasksLink`). */
export const getOrganizationClientTasksLink = ({
    workspaceId,
    viewId,
    closeId,
}: OrganizationClientTasksLinkParams) => {
    const searchParams = new URLSearchParams({ clientId: workspaceId });
    if (viewId) {
        searchParams.set("view", viewId);
    }
    if (closeId) {
        searchParams.set("closeId", closeId);
    }
    return `/clients-tasks?${searchParams.toString()}`;
};

/** Home (the Work page) on All work filtered to one client (see `useWorkPageLanding`). */
export const getOrganizationClientWorkLink = (workspaceId: string) => {
    const searchParams = new URLSearchParams({ clientId: workspaceId });
    return `/clients-work?${searchParams.toString()}`;
};
